import { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from './AuthContext';
import { InstructorContext } from './InstructorContext';

function ProtectedRoute({ children }) {
    const { currentUser, loading: authLoading } = useContext(AuthContext);
    const { accessValid, loading: instructorLoading } = useContext(InstructorContext);

    if (authLoading || instructorLoading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', color: '#666' }}>
                Loading...
            </div>
        );
    }

    if (!currentUser) {
        return <Navigate to="/professor-login" replace />;
    }

    if (accessValid === false) {
        return <Navigate to="/access-expired" replace />;
    }

    return children;
}

export default ProtectedRoute;
